import { appInsights } from 'utilities/telemetry';
import { useLocation } from 'react-router';
import { ReportRoutes } from 'Routes';
import { useCallback } from 'react';

const events = {
  GeneratedReport: 'User generated report',
  AdjustedReportContent: 'User adjusted report content',
  EditedReportLayout: 'User edited report layout',
  SavedReportLayoutForSession: 'User saved edited report layout for session',
  SavedReportLayoutForOrg: 'User saved edited report layout for organization',
  DiscardedReportLayoutChanges: 'User discarded report layout changes',
  AddedChart: 'User added chart to report',
  RemovedChart: 'User removed chart from report',
  PrintedReport: 'User printed report',
  DownloadedReport: 'User downloaded report',
} as const;

const getReportType = (pathname: string): string | null => {
  for (const reportType in ReportRoutes) {
    for (const reportSubType in ReportRoutes[reportType]) {
      if (pathname.includes(ReportRoutes[reportType][reportSubType])) {
        return `${reportType}.${reportSubType}`;
      }
    }
  }
  return null;
};

export const useTelemetry = () => {
  const { pathname } = useLocation();

  const trackEvent = useCallback(
    (name: string, properties?: { [key: string]: any }) => {
      const reportType = getReportType(pathname);
      if (reportType) {
        properties = { ...properties, reportType };
      }

      appInsights?.trackEvent({ name }, properties);
    },
    [pathname]
  );

  const trackException = useCallback(
    (error: Error, properties?: { [key: string]: any }) => {
      const reportType = getReportType(pathname);
      if (reportType) {
        properties = { ...properties, reportType };
      }

      appInsights?.trackException({ exception: error }, properties);
    },
    [pathname]
  );

  const trackPageView = useCallback((name: string) => {
    appInsights?.trackPageView({ name });
  }, []);

  return { trackEvent, trackException, trackPageView, events };
};
